import { EntryMode } from '@/features/shared/models/EntryMode';
import { MenuItem } from '@/features/shared/models/MenuItem';
import { FormatDateISO } from '@/helpers/DateFormatHelpers';
import { defineStore } from 'pinia';

export const useBaseStore = defineStore('base', {
    state: () => ({
        selectedDate: new Date(),
        lineNumber: null as string | null,
        tripId: null as string | null,
        isOnline: true,
        isLoading: false,
        loadingCount: 0,
        entryMode: EntryMode.CLICKER,
        departuresPage: null as MenuItem | null,
        tripPage: null as MenuItem | null
    }),
    getters: {
        isToday(state) {
            const today = new Date();
            return (
                state.selectedDate.getDate() === today.getDate() &&
                state.selectedDate.getMonth() === today.getMonth() &&
                state.selectedDate.getFullYear() === today.getFullYear()
            );
        },
        isPastDay(state) {
            if (this.isToday) {
                return false;
            }
            const today = new Date();
            return state.selectedDate < today;
        },
        isFutureDay(state) {
            if (this.isToday) {
                return false;
            }
            const today = new Date();
            return state.selectedDate > today;
        },
        calendarDay(state) {
            return FormatDateISO(state.selectedDate);
        }
    },
    actions: {
        clearMenuItems() {
            this.departuresPage = null;
            this.tripPage = null;
        },
        clearTripMenuItem() {
            this.tripPage = null;
        },
        setIsLoading(isLoading: boolean) {
            if (isLoading) {
                this.loadingCount = this.loadingCount + 1;
                this.isLoading = true;
            } else {
                const loadingCount = this.loadingCount - 1;
                this.loadingCount = loadingCount;
                if (loadingCount <= 0) {
                    this.isLoading = false;
                }
            }
        }
    }
});
